export default function Marquee({ items }) {
  return (
    <div
      className="relative overflow-hidden border-y border-line/60 bg-charcoal/20 py-5"
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <div className="animate-marquee flex w-max items-center hover:[animation-play-state:paused]">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0 items-center">
            {items.map((item, i) => (
              <span key={i} className="flex items-center">
                <span className="whitespace-nowrap px-8 font-mono text-[11px] uppercase tracking-[0.35em] text-slate-500">
                  {item}
                </span>
                <span className="h-1.5 w-1.5 rotate-45 border border-glow/50" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
